export const NAV_LINK_ITEMS = [
  {
    title: 'Home',
    url: '/',
  },
  {
    title: 'Category',
    url: '/category',
  },
  {
    title: 'About',
    url: '/about',
  },
];

export const COPYRIGHT = `© 2021-${new Date().getFullYear()} 김민지 All Rights Reserved.`;

export const RSS_URL = '/rss.xml';
